import { ReactNode } from 'react'

import { RunFlags } from '../../../../StayTimeline.items'
import * as S from './MessageBubble.styles'

interface MessageBubbleProps {
  isInbound: boolean
  flags: RunFlags
  avatar: ReactNode
  header: ReactNode
  children: ReactNode
}

export const MessageBubble = ({
  isInbound,
  flags,
  avatar,
  header,
  children,
}: MessageBubbleProps) => {
  const avatarSlot = <S.AvatarSlot>{flags.isFirst ? avatar : null}</S.AvatarSlot>

  return (
    <S.Row $isInbound={isInbound} $isRunEnd={flags.isLast}>
      {isInbound ? avatarSlot : null}

      <S.Column $isInbound={isInbound}>
        {flags.isFirst ? <S.Header>{header}</S.Header> : null}
        {children}
      </S.Column>

      {isInbound ? null : avatarSlot}
    </S.Row>
  )
}
